import React from 'react'

function Header() {
    return (
        <>
        <header class="site-header header style-1">	
            
            
            <div class="sticky-header main-bar-wraper">
                <div class="main-bar clearfix bg-secondary text-white">
                    <div class="container-fluid clearfix inner-bar">
                        <div class="logo-header logo-dark">
                            <a href="/"><img src="assets/images/logo-conecta-sm.svg" alt="logo"/></a>
                        </div>
                        <button class="w3menu-toggler navicon" type="button" data-target="#W3Menu">
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                        <div class="menu-close fade-overlay"></div>
                        <div class="header-nav w3menu w3menu-end mo-left" id="W3Menu">
                            <div class="logo-header logo-dark">
                                <a href="/"><img src="assets/images/logo-conecta-sm.svg" alt=""/></a>
                            </div>
                            <ul class="nav navbar-nav">
                                <li class="has-mega-menu auto-width menu-left">
                                    <a href="/"><span>Inicio</span></a>
                                </li>
                                <li class="sub-menu-down">
                                    <a href="/contact-center-soluciones-inteligentes"><span>Contact Center</span> <i class="fas fa-chevron-down tabindex"></i></a>
                                    {/* <ul class="sub-menu">
                                        <li><a href="/contact-center-soluciones-inteligentes">Soluciones inteligentes</a></li>
                                    </ul> */}
                                </li>
                                <li class="sub-menu-down">
                                    <a href="/consultoría-integral"><span>Consultoria</span> <i class="fas fa-chevron-down tabindex"></i></a>
                                    {/* <ul class="sub-menu">						
                                        <li><a href="team.html">Team</a></li>
                                        <li><a href="team-detail.html">Team Detail</a></li>
                                    </ul> */}
                                </li>
                            </ul>
                        </div>
                    
                        <div class="extra-nav">
                            <div class="extra-cell">						
                                <ul class="header-right">
                                    <li class="nav-item">
                                        <a href="#" class="btn btn-primary btn-hover1">
                                            Contactanos
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <button type="button" class="toggle-nav-btn" data-bs-toggle="offcanvas" data-bs-target="#headerSidebar" aria-controls="offcanvasLeft">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    
                    </div>
                </div>
            </div>
            <div class="offcanvas dz-offcanvas offcanvas offcanvas-end" tabindex="-1" id="headerSidebar">
                <button type="button" class="btn-close m-t10 m-l10" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                <div class="offcanvas-body">
                    <div class="widget">
                        <div class="sidebar-header m-b20">
                            <a href="/"><img src="images/logo-footer.svg" alt="/"/></a>
                        </div>
                        <p>Asesoría legal y financiera personalizada para empresas y personas. Especialistas en financiamiento, portafolios, derecho mercantil, civil, familiar y fiscal.</p>
                    </div>
                    
                    <div class="widget">
                        <div class="widget-title">
                            <h4 class="title">Contactanos</h4>
                        </div>
                        <ul class="list-check">
                            <li>Napoles, Benito Juarez, Ciudad de México</li>
                            <li><a href="mailto:contacto@conectaycrece.com.mx" class="text-body">contacto@conectaycrece.com.mx</a></li>
                            <li><a href="tel:+525578326653" class="text-body">5578326653</a></li>
                        </ul>
                    </div>
                </div>
            </div>

             <a href="https://api.whatsapp.com/send?phone=5578326653" class="btn-wsp" target="_blank">
                <i class="fab fa-whatsapp"></i>
            </a>
        </header>
        </>
    )
}

export default Header